import { VaxiluskernaMap } from './map/vaxiluskernamap';
import { MenuButton } from './map/components/menubutton';

import { MenuView } from './map/components/menuview';
import { MapView } from './mapview';

import { CookieHelper } from './io/cookiehelper';


import { ArticleView } from './articleview';
import { ArticlesView } from './articlesview';


import { Reloader } from './core/reloader';
import { ReceptionOutDatabaseShortInfo, Receptions } from './io/receptions';
import { UserLocation } from './core/userlocation';;
import { GoogleMaps } from './core/googlemaps';
import { OnEventDispatcher } from './core/on-event-dispatcher';
import { StateManager, StateManagerEventData } from './core/statemanager';
import { loadJson } from './core/loadjson';

if(window.location.href.indexOf("localhost")>=0) {
    let reloader = new Reloader();
    reloader.on("reload", () => {
        setTimeout(() => {
            window.location.reload();
        }, 300);
    });
}

const titlePrefix:string = "Travelhealth - ";

declare const $:any;
declare const firebase:{
    app:any,
    db: {
        functions: {
            getDatabase: (app:any)=>any;
            ref: (db:any, path:string)=>any;
            onValue: (ref:any, fn:Function)=>any;
        }
    }
}

export type ApplicationType = {
    receptionSearchResultCount: number;
    events:OnEventDispatcher;
    stateManager:StateManager;
    map?:VaxiluskernaMap;
    mapInitialized:boolean;
    menuView?:MenuView;
    mapView?:MapView;
    menuButton?: MenuButton;
    initMap: () => Promise<void>;
    setTitle: (text:string, usePrefix?:boolean) => void;
    setDataSlug: (dataSlug:string) => void;
    getDataSlug: () => string;
    clearContent: () => void;
    showLoader: () => void;
    hideLoader: () => void;
};
export const Application:ApplicationType = {
    receptionSearchResultCount: 0,
    mapInitialized: false,
    events: new OnEventDispatcher(),
    stateManager: new StateManager(),
    initMap: ():Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                Application.showLoader();

                await GoogleMaps.init();
                await Receptions.load();

                Application.map = new VaxiluskernaMap();
                await Application.map.mount($(".map-container"));
                
                for(let m in Receptions.receptions) {
                    let c = Receptions.receptions[m];
                    let marker = Application.map.addReceptionMarker(c);
                    marker.on("click", () => {
                        Application.stateManager.setPath("/vaccination/"+c.slug);
                    });
                }
                
                Application.map.googlemaps.fitBounds(Receptions.bounds, {x: 100, y: 100});
                Application.map.showReceptionMarkers();
                Application.map.hideDestinations();

                Application.hideLoader();
                
                Application.mapInitialized = true;

                resolve();
            } catch(e) {
                reject(e);
            }
        });
    },
    setTitle: (text:string, usePrefix:boolean = true) => {
        if(usePrefix) {
            document.title = titlePrefix + text;
        } else {
            document.title = text;
        }
    },
    setDataSlug: (dataSlug:string) => {
        $(".content").attr("data-slug", dataSlug);
    },
    getDataSlug: ():string => {
        return $(".content").attr("data-slug");
    },
    clearContent: () => {
        $(".content").html("");
    },
    showLoader: () => {
        $(".loader").addClass("show");
    },
    hideLoader: () => {
        $(".loader").removeClass("show");
    }
};

Application.events.on("open_reception", (_ev:string, reception:ReceptionOutDatabaseShortInfo) => {
    $(".content").attr("data-slug", "/vaccination/"+reception.slug);
    document.title = titlePrefix + reception.name;

    reception.marker.setSelected(true);
    Application.map.zoomInOnReception(reception);
});
Application.events.on("close_reception", (_ev:string, reception:ReceptionOutDatabaseShortInfo) => {
    reception.marker.setSelected(false);
});

let wasMapView = false;
let firstStateEvent = true;
Application.stateManager.on("change", async (_ev:string, data:StateManagerEventData) => {
    Application.menuView.close();
    if(data.parts==null||data.parts.length==0||data.parts[0]=="") {
        //root (map)
        Application.setDataSlug("/");
        $(".content").removeClass("scroll");
        $("body").attr("data-view", "map");
        
        Application.setTitle("Hitta vaccinatör nära dig");

        if(Application.mapView==null||!wasMapView) {
            if(!firstStateEvent) {
                Application.clearContent();
            }
            Application.mapView = new MapView($(".content"), null);
        }

        if(Application.mapView?.sideView?.content!=null) {
            Application.mapView.sideView.close();
        };

        if(!Application.mapInitialized) {
            await Application.initMap();
        }

        Application.map.googlemaps.unlockPan();
        Application.map.googlemaps.unlockZoom();
        Application.map.setWorldMode(false);
        
        wasMapView = true;
    } else if(data.parts.length>=2&&data.parts[0]=="vaccination"&&data.parts[1].length>2) {
        //reception in focus (map)
        $(".content").removeClass("scroll");

        $("body").attr("data-view", "map");

        if(Application.mapView==null||!wasMapView) {
            if(!firstStateEvent) Application.clearContent();
            Application.mapView = new MapView($(".content"), null);
        }

        if(!Application.mapInitialized) {
            await Application.initMap();
        }

        Application.map.googlemaps.unlockPan();
        Application.map.googlemaps.unlockZoom();
        Application.map.setWorldMode(false);
        
        let receptionSlug:string = data.parts[1];
        Application.mapView.sideView.open(receptionSlug);

        wasMapView = true;

    } else if(data.parts.length>=1&&data.parts[0]=="resevaccin") {
        //resevaccin articles
        if(Application.mapView?.sideView?.content!=null) {
            Application.mapView.sideView.close();
        };
        if(!firstStateEvent) {
            Application.clearContent();
            Application.setDataSlug("/");
        }
        $(".content").addClass("scroll");
        wasMapView = false;

        if(data.parts.length>1&&data.parts[1].length>2) {
            $("body").attr("data-view", "article");
            let articleView = new ArticleView($(".content"), data.path);
        } else {
            $("body").attr("data-view", "article-list");
            let articlesView = new ArticlesView($(".content"), data.path);
        }
        
    } else if(data.parts.length>=1) {
        if(Application.mapView?.sideView?.content!=null) {
            Application.mapView.sideView.close();
        };
        if(!firstStateEvent) $(".content").html("");
        $(".content").addClass("scroll");
        wasMapView = false;

        let slug = data.parts[0];
        try {
            $("body").attr("data-view", "article");
            let articleView = new ArticleView($(".content"), "/"+slug);
        } catch(e) {
            console.error(e);
            alert('Sidan ' + data.path + ' kunde inte hittas.');
        }
    }
    firstStateEvent = false;
});

$(document).ready(async () => {
    //await GoogleMaps.init();
    //await Receptions.load();
    //await WorldGeom.load();
    //await Diseases.load();

    /*let rewriteCookieExpiration = () => {
        let expirationVal = new Date(Date.now() + (1000*60*60)); //1 hour from now as per spec.
        let rewriteVals = ['cookie_consent_level', 'cookie_consent_user_accepted', 'cookie_consent_user_consent_token'];
        setTimeout(() => {
            for(let m in rewriteVals) {
                let cValName:string = rewriteVals[m];
                let cVal:any = CookieHelper.getCookie(cValName);
                //console.log(cValName + " = " + cVal);
                if(cVal!=null&&cVal!="") {
                    CookieHelper.setCookie(cValName, cVal, {expires: expirationVal});
                    //console.log("Rewrote expiration of cookie '"+cValName+"' to "+(expirationVal.toTimeString()));
                }
            }
        }, 500);
    }
    let cookieBanner = $('.freeprivacypolicy-com---nb-simple');
    if(cookieBanner!=null&&cookieBanner.length>0) {
        cookieBanner.find(".cc-nb-buttons-container .cc-nb-okagree").on("click", () => {
            rewriteCookieExpiration();
        });
        cookieBanner.find(".cc-nb-buttons-container .cc-nb-reject").on("click", () => {
            rewriteCookieExpiration();
        });
    }
    rewriteCookieExpiration(); //<-- rewrite potential already set cookies*/

	(async () => {
        $(".loader").on("click", (e:any) => {
            e.preventDefault();
            e.stopPropagation();
        });

        $(".logo").on("click", (e:any) => {
            e.preventDefault();
            e.stopPropagation();
            Application.stateManager.setPath("/");
        });

        Application.menuView = new MenuView($("body"));
        Application.menuButton = new MenuButton($("body"));

        Application.events.on("locate_user_requested", async () => {
            if(Application.mapInitialized) {
                try {
                    let loc = await UserLocation.getCurrent();
                    let closestReceptions = Receptions.getClosestTo(loc);
                    Application.map.setBoundsToIncludeReceptions(closestReceptions.slice(0, 10));
                } catch(e) {
                    console.error("User has denied location service:", e);
                }
            }
        });
        await Application.stateManager.init();
	})();
});